import { siteInfo } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-secondary-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="text-xl font-heading font-bold text-accent-400">{siteInfo.name}</span>
            <p className="mt-3 text-sm text-secondary-400 leading-relaxed">
              90影视专注为8090后提供国产剧、韩剧、综艺、动漫、电影等高清在线观看服务，每日更新，全集免费，是追剧看电影的首选影视网站。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-secondary-100 mb-4">快捷导航</h3>
            <div className="flex flex-col gap-2">
              <a href="#ranking" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">热播榜单</a>
              <a href="#carousel" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">焦点专题</a>
              <a href="#updates" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">最新更新</a>
              <a href="#faq" className="text-sm text-secondary-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-secondary-100 mb-4">内容分类</h3>
            <div className="flex flex-wrap gap-2">
              {['国产剧', '韩剧', '综艺', '动漫', '电影', '纪录片', '短剧'].map((cat) => (
                <span key={cat} className="text-xs bg-secondary-800 text-secondary-300 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {cat}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-secondary-100 mb-4">合作伙伴</h3>
            <p className="text-sm text-secondary-500 leading-relaxed">
              诚邀优质影视内容方与品牌方合作，共同服务8090后影迷群体。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-500">
            &copy; 2020-2026 {siteInfo.name}. All rights reserved. 仅供学习交流，请勿用于商业用途。
          </p>
          <div className="flex items-center gap-5">
            <a href="#hero" className="text-xs text-secondary-500 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">回到顶部</a>
            <a href="#contact" className="text-xs text-secondary-500 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}